import React, {useState} from 'react';
import Modal from '../../../../Components/Modal';
import Form, { Actions, Money as MoneyField, NumberValidator, Switch } from '../../../../Components/Form';
import { payoutFees, useBalance } from '../../../../Data/Balance';
import Money from '../../../../Components/Formatting/Money';
import Grid from '../../../../Components/Formatting/Grid';
import { PageLoading } from '../../../../Components/Loading';
import Alert from '../../../../Components/Alert';
import { useSession } from '../../../../Components/Session';
import { levels } from '../../../../Data/Admin';

const minPayout = 500;

const RequestPayout = ({isOpen, setIsOpen, onChanged}) => {
    return <Modal title="Request payout" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner onChanged={onChanged} />}
    </Modal>
}

const Inner = ({onChanged}) => {
    const {balance, requestPayout} = useBalance(false);
    const [payoutSettings, setPayoutSettings] = useState({});
    const {isAdmin} = useSession();

    if (!balance) {
        return <PageLoading />;
    }

    const insufficientBalance = balance.payablePence < minPayout;
    const insufficientBalanceNotAdmin = insufficientBalance && !isAdmin(levels.SUPER);

    return <>
        {insufficientBalance && <Alert
            theme="warning"
            title="Insufficient balance"
            message={<>
                Your payable balance is less than £{minPayout / 100}, you need to have at least £{minPayout / 100} to request a payout.
            </>}
        />}

        <Form
            onChange={setPayoutSettings}
            afterSubmit={onChanged}
            data={{amount: balance.payablePence}}
            onSubmit={data => requestPayout(data.amount, data.instant)}
            closeModalOnSubmit
            waitForData
        >
            <MoneyField name="amount"
                label="Amount"
                validators={[
                    NumberValidator(minPayout, balance.payablePence, `Payout must be at least £${minPayout / 100} and no more than your payable balance of £${balance.payablePence / 100}`)
                ]}
                disabled={insufficientBalanceNotAdmin}
            />
            <Switch name="instant"
                label="Instant payout"
                help={<>
                    There's a fee of 1.5% for instant payouts, minimum 40p.
                </>}
                disabled={insufficientBalanceNotAdmin}
            />

            <FeeInfo {...{payoutSettings}} />

            <Actions submit={{label: 'Request', disabled: insufficientBalanceNotAdmin}}
                cancel
            />
        </Form>
    </>
}

const FeeInfo = ({payoutSettings}) => {
    if (!payoutSettings.amount || payoutSettings.amount < minPayout) {
        return null;
    }

    let fee = 0, net = 0;
    if (payoutSettings.instant) {
        fee = Math.max(40, payoutSettings.amount * 0.015);
    } else {
        fee = payoutFees(payoutSettings.amount);
    }
    net = payoutSettings.amount - fee;

    return <Grid className="ml-2" items={[
        [
            <strong>Fee</strong>,
            <Money pence={fee} />
        ],
        [
            <strong>Net</strong>,
            <Money pence={net} />
        ]
    ]} />
}

export default RequestPayout;
